import { render, staticRenderFns } from "./ImageDisplayOverlay.vue?vue&type=template&id=058a0de8&scoped=true"
import script from "./ImageDisplayOverlay.vue?vue&type=script&lang=js"
export * from "./ImageDisplayOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a0de8",
  null
  
)

export default component.exports